import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const REGIONS = ["All", "North", "West", "Central", "East", "South"];

export default function Delegations() {
  const [items, setItems] = useState([]);
  const [region, setRegion] = useState("All");

  useEffect(() => { api.get("/delegations").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const filtered = items.filter((d) => region === "All" || d.region === region);

  return (
    <div className="section py-12 sm:py-16" data-testid="delegations-page">
      <p className="kicker mb-2">Participating Delegations</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl text-amber-50">{items.length} Nations. One Continent.</h1>
      <p className="mt-3 max-w-2xl text-amber-100/60">Every delegation brings its heritage, its people and its champion to the continental stage.</p>

      <div className="mt-8 flex flex-wrap gap-2">
        {REGIONS.map((r) => (
          <button key={r} onClick={() => setRegion(r)} data-testid={`deleg-region-${r.toLowerCase()}`}
            className={`rounded-full px-4 py-1.5 text-xs font-display uppercase tracking-wider transition-all ${region === r ? "gold-bg text-obsidian" : "border border-gold/25 text-gold/70 hover:border-gold/60"}`}>
            {r === "All" ? "All Africa" : r}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" data-testid="delegations-grid">
        {filtered.map((d) => (
          <Link key={d.code} to={`/delegations/${d.code}`} data-testid={`delegation-${d.code}`} className="card-lux p-5">
            <div className="flex items-center justify-between">
              <span className="text-4xl">{d.flag}</span>
              <span className="rounded-full border border-gold/25 px-2 py-0.5 font-mono text-[0.6rem] uppercase tracking-wider text-gold/70">{d.code}</span>
            </div>
            <h3 className="mt-4 font-serif text-xl text-amber-50 leading-tight">{d.name}</h3>
            <p className="mt-1 text-xs text-muted-foreground">{d.capital} · {d.region} Africa</p>
            {d.population > 0 && <p className="mt-1 font-mono text-xs text-gold/60">{d.population}M people</p>}
          </Link>
        ))}
      </div>
    </div>
  );
}
